import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";

import eventBus from "src/utils/eventBus";
import hotIcon from "src/assets/hot.svg";
import { getChannelDetail } from "src/api/ChannelApi";

interface SecuritiesCompanyTableProps {
    contents: {
        channel_title?: string;
        photo?: string;
        subscribe_cnt?: number;
        corp_name?: string;
        channel_id?: string;
        corp_id?: number;
        sector_id?: number;
        sector_name?: string;
    }[];
}

const SecuritiesCompanyTable: React.FC<SecuritiesCompanyTableProps> = ({ contents }) => {
    const recommend = useSelector((state: RootState) => state.main.recommend);
    const handleOpenModal = ( channel_id ) => {
        const fetchData = async () => {
            const response = await getChannelDetail(channel_id);
            if (response) {
                eventBus.emit("channelPreviewModal:show", { channel: response.data });
            } 
            else {
                alert("채널 상세정보 불러오기 실패!");
            }
        };
        fetchData();
    };

    return (
        <div className="table">
        <table className="table table-white table-hover">
            <colgroup>
                <col style={{width: "15%"}} />
                <col style={{width: "70%"}} />
                <col style={{width: "15%"}} />
            </colgroup>
            <thead>
                <tr>
                    <th className="text-center text-black3">
                        <p>순위</p>
                    </th>
                    <th className="text-center text-black3">
                        <p>채널명</p>
                    </th>
                    <th className="text-center text-black3">
                        <p>구독자</p>
                    </th>
                </tr>
            </thead>
            <tbody>
                {recommend.map((value, index) =>
                    value.recommend_gb === 'COMPANY' ? (<tr 
                        className="highlight"
                        onClick={() => handleOpenModal(value.channel_id)} 
                        style={{ cursor: "pointer" }}>
                        <td className="text-center gap-2">
                            <small className="text-red fw-semibold p-test">추천</small>
                        </td>
                        <td>
                        <a className="d-flex align-items-center gap-2">
                            <div className="user_img" style={{ backgroundImage: `url(${value.photo})`}}></div>
                            <div className="txt">
                                <p className="fw-semibold ellipsis-box p-test">
                                    {value.channel_title}
                                </p>
                            </div>
                        </a>
                        </td>
                        <td className="text-center text-red">
                            <i><img className="hot-img" src={hotIcon} alt="" /></i>
                        </td>
                    </tr>
                ): null )}
                {contents.map((content, index) => (
                    <tr 
                        key={index}
                        onClick={() => handleOpenModal(content.channel_id)} 
                        style={{ cursor: "pointer" }}>
                        <td className="text-center">
                            <small className={`number${index <= 2 ? " bg-red text-white" : ""}`}>{index + 1}</small>
                        </td>
                        <td>
                        <a className="d-flex align-items-center gap-2">
                            <div className="user_img" style={{ backgroundImage: `url(${content.photo})`}}></div>
                            <div className="txt">
                                <p className="fw-semibold ellipsis-box p-test">
                                    {content.channel_title}
                                </p>
                            </div>
                        </a>
                        </td>
                        <td className="text-center text-red">{content.subscribe_cnt.toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    );
};

export default SecuritiesCompanyTable;